import React from 'react';
import { ArrowLeft } from 'react-feather';
import { routes } from 'constants/config';

const EventsDashboardBackLink = () => (
  <a
    href={routes.IN_PERSON_TRAINING.EVENTS_DASHBOARD}
    className="EventRegistrationHeader-Link"
    tabIndex="0"
  >
    <ArrowLeft className="EventRegistrationHeader-Link-Icon" size={24} />
    {t('in_person_training.events.my_training_events')}
  </a>
);

export default EventsDashboardBackLink;
